<template>
  <date-range-picker
    ref="picker"
    opens="right"
    :date-range="dateRange"
    :min-date="minDate"
    :max-date="maxDate"
    :append-to-body="true"
    :locale-data="locale"
    :ranges="false"
    @update="update"
  >
    <template v-slot:input="picker" style="min-width: 350px">
      <template v-if="picker.startDate && picker.endDate">
        {{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}
      </template>

      <template v-else class="datownik">Wybierz datę</template>
    </template>
  </date-range-picker>
</template>

<script>
import dayjs from 'dayjs';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: { DateRangePicker },
  props: {
    minDate: { type: [Date, String] },
    maxDate: { type: [Date, String] },
    schema: { type: Object, required: true }
  },
  data() {
    return {
      dateRange: {
        startDate: this.schema.start.$model,
        endDate: this.schema.end.$model
      },
      locale: {
        direction: 'ltr',
        format: 'dd.mm.yyyy',
        separator: ' - ',
        applyLabel: 'Wybierz',
        cancelLabel: 'Anuluj',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Nd', 'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
        monthNames: [
          'Styczeń',
          'Luty',
          'Marec',
          'Kwiecień',
          'Maj',
          'Czerwiec',
          'Lipiec',
          'Sierpień',
          'Wrzesień',
          'Październik',
          'Listopad',
          'Grudzień'
        ],
        firstDay: 1
      }
    };
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('DD.MM.YYYY');
    },
    update(range) {
      this.schema.start.setValue(this.formatDate(range.startDate));
      this.schema.end.setValue(this.formatDate(range.endDate));
      this.$emit('change');
    }
  }
};
</script>
